import { render, staticRenderFns } from "./ButtonBar.vue?vue&type=template&id=5665130d&scoped=true&"
import script from "./ButtonBar.vue?vue&type=script&lang=js&"
export * from "./ButtonBar.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBar.vue?vue&type=style&index=0&id=5665130d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5665130d",
  null
  
)

export default component.exports